"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOS_PHOTO_UPLOAD_REGEX = exports.MAC_REGEX = exports.WEBVIEW_REGEX = exports.IOS_REGEX = exports.ANDROID_REGEX = exports.TOUCH_REGEX = exports.MENTION_MARKER = exports.MENTION_REGEX_G = exports.MENTION_REGEX = void 0;
// eslint-disable-next-line
exports.MENTION_REGEX = /\[@([^\]]*)]\(@([^\)]*)\)/g;
// eslint-disable-next-line
exports.MENTION_REGEX_G = /\[@([^\]]*)]\(@([^\)]*)\)/g;
exports.MENTION_MARKER = '_';
exports.TOUCH_REGEX = /iphone|ipad|ipod|android|iemobile|blackberry/i;
exports.ANDROID_REGEX = /android/i;
exports.IOS_REGEX = /iphone|ipad|ipod/i;
exports.WEBVIEW_REGEX = /WebView/i;
exports.MAC_REGEX = /macintosh/i;
exports.IOS_PHOTO_UPLOAD_REGEX = /^[0-9A-Z]{8}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{4}-[0-9A-Z]{12}/;
